import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNavbar from "./ui/countdown/topNavbar/topNavbar";
import MiddleHeader from "./ui/headers/middleHeader";
import Searchbar from "./includes/Searchbar";
import Footer from "./ui/footer/footer";
import Searchfield from "./ui/searchfield/Searchfield";

function LandingPageList() {
  const [landingPages, setLandingPages] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchLandingPages = async () => {
      try {
        const response = await axios.get("/blog"); // Assuming all content comes from the same endpoint
        const landings = response.data.filter((a) => a.type === "landing");
        setLandingPages(landings);
      } catch (error) {
        console.error("Error fetching landing pages:", error);
      }
    };

    fetchLandingPages();
  }, []);

  return (
    <div className="page-wrapper">
      <header className="header">
        <TopNavbar />
        <MiddleHeader />
        <Searchbar />
        <Searchfield />
      </header>

      <main className="main">
        <div className="page-header">
          <div className="container" style={{ marginBottom: "1rem" }}>
            <h1
              className="page-title mb-0 text-5xl font-bold"
              style={{ marginTop: "1rem" }}
            >
              Feuerwerk Händler Landingpages
            </h1>
          </div>
        </div>

        <div className="page-content mb-10 pb-2">
          <div className="container">
            <div className="row gutter-lg">
              <div className="main-content">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1.5rem",
                    justifyContent: "start",
                  }}
                >
                  {landingPages
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .map((page) => (
                      <article
                        key={page.id}
                        className="post post-grid-type overlay-zoom mb-6"
                        style={{
                          flex: "1 1 calc(25% - 1.5rem)", // 4 per row with gap
                          maxWidth: "calc(25% - 1.5rem)",
                          boxSizing: "border-box",
                        }}
                      >
                        <figure className="post-media br-sm">
                          <a href={`/landingpages/${page.slug}`}>
                            <img
                              src={page.og_image || "default-image.jpg"}
                              alt={page.title}
                              style={{
                                width: "100%",
                                height: "auto",
                                maxHeight: "250px",
                                objectFit: "cover",
                              }}
                            />
                          </a>
                        </figure>
                        <div className="post-details">
                          <h4 className="post-title">
                            <a href={`/landingpages/${page.slug}`}>
                              {page.title}
                            </a>
                          </h4>
                          <div className="post-content">
                            <a href={`/landingpages/${page.slug}`}>
                              <p style={{ color: "#999" }}>
                                {page.excerpt || "Keine Vorschau verfügbar..."}
                              </p>
                            </a>
                            <a href={`/landingpages/${page.slug}`}>
                              <span className="btn btn-link btn-primary">
                                (mehr erfahren)
                              </span>
                            </a>
                          </div>
                          <div className="post-meta">
                            <span className="post-date">
                              {new Date(page.created_at).toLocaleDateString(
                                "de-DE"
                              )}
                            </span>
                          </div>
                        </div>
                      </article>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default LandingPageList;